import React, { useEffect, useState } from 'react'

import './Checkbox.css'
import { useFormState } from '../../../pages/insertionPage/wizard/useFormState'
import { ContentStateProperty } from '../../../../@types/types'
import { Checkbox as CosmaCheckbox } from 'is24-corecss'

export type CheckboxProps = {
  id: string
  name: ContentStateProperty
  checked: boolean
  label?: string | React.ReactNode
  onChange: (name: ContentStateProperty, checked: boolean) => void
  onBlur?: (value: boolean, isUnchanged: boolean) => void
}

const Checkbox: React.FC<CheckboxProps> = ({ id, name, onChange, checked, label, onBlur }) => {
  const [state, setState] = useState<{
    isUnchanged: boolean
    lastValue: boolean
    currentChecked: boolean
  }>({
    isUnchanged: true,
    lastValue: checked,
    currentChecked: checked,
  })
  const { setTouched } = useFormState()
  useEffect(() => {
    setState((prev) => ({ ...prev, lastValue: checked, currentChecked: checked }))
  }, [checked])

  const doChange = () => {
    onChange(name, !state.currentChecked)
    setState((prev) => ({ ...prev, currentChecked: !prev.currentChecked }))
  }

  const onLostFocus = ({
    relatedTarget,
    currentTarget: { checked: newChecked },
  }: React.FocusEvent<HTMLInputElement>) => {
    setTouched(name as ContentStateProperty)
    if (state.lastValue !== state.currentChecked && relatedTarget?.className !== `${id}-checkbox-container`) {
      onBlur && onBlur(newChecked, state.isUnchanged)
      setState((prev) => ({ ...prev, lastValue: newChecked, isUnchanged: false }))
    }
  }

  return (
    <ul>
      <li id={`${id}-checkbox-container`} className='checkbox-container' tabIndex={-1}>
        <CosmaCheckbox
          id={id}
          label={label ? label : ''}
          name={name}
          onChange={doChange}
          checked={state.currentChecked}
          onBlur={onLostFocus}
          tabIndex={0}
        />
      </li>
    </ul>
  )
}

export default Checkbox
